'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'circle-2';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e0ef';
var svgPathData = ['M32 256a224 224 0 1 0 448 0 224 224 0 1 0 -448 0zm160-78.7c0-8.8 7.2-16 16-16l57.8 0c29.9 0 54.2 24.3 54.2 54.2 0 21.2-12.3 40.4-31.6 49.2L252 281.4c-15.5 7.1-26 21.8-27.7 38.6l79.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-10.9c0-31.3 18.2-59.7 46.7-72.7l36.4-16.7c7.9-3.6 12.9-11.5 12.9-20.2 0-12.2-9.9-22.2-22.2-22.2l-57.8 0c-8.8 0-16-7.2-16-16z', 'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM208 161.3c-8.8 0-16 7.2-16 16s7.2 16 16 16l57.8 0c12.2 0 22.2 9.9 22.2 22.2 0 8.7-5.1 16.5-12.9 20.2l-36.4 16.7c-28.4 13-46.7 41.4-46.7 72.7l0 10.9c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-79.7 0c1.8-16.7 12.2-31.5 27.7-38.6l36.4-16.7c19.3-8.8 31.6-28.1 31.6-49.2 0-29.9-24.3-54.2-54.2-54.2l-57.8 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircle2 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;